/**
 * Збірка для вікна Tauri ([ADR-0047]). Константа часу збірки: у вебі Vite
 * підставляє `false`, і гілки під нею з вебової збірки викидаються.
 */
export const DESKTOP: boolean = import.meta.env["VITE_DESKTOP"] === "1";
